<template>
  <bita-modal
    :id="id"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoadingModal"
    @close="reset"
  >
    <div slot="body">
<div class="row mb-3">
      <state-filter
  v-model="formData.state_id"
  type="wallet_report"
/>
        </div>
      <bita-form ref="form">
        <div slot="body">
          <div class="row align-items-end">
  <bita-datepicker
    type="date"
    name="from"
    label="از تاریخ"
    input-class="form-control"
    validation-container-class="col-lg-4"
    v-model="formData.from"
    rules="required"
  />

  <bita-datepicker
    type="date"
    name="to"
    label="تا تاریخ"
    input-class="form-control"
    validation-container-class="col-lg-4"
    v-model="formData.to"
    rules="required"
  />

  <bita-input
    type="text"
    name="search"
    label="سرچ"
    validation-container-class="col-lg-4"
    input-class="form-control"
    v-model.lazy="formData.search"
    subtitle="سرچ بر اساس کدملی و شماره موبایل"
  />
</div>

        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <div class="d-flex flex-column flex-md-row">
        <div class="col-12 col-md-2">
          <bita-bootbutton
            type="primary"
            title="دانلود اکسل"
            icon="fas fa-file-excel"
            class="w-100"
            @click.native="handleSubmit"
          />
        </div>
        <div class="col-12 col-md-1">
          <bita-bootbutton
            class="w-100 text-danger border-0 bg-transparent"
            type="danger"
            title="بستن"
            icon="fas fa-times"
            data-dismiss="modal"
          />
        </div>
      </div>
    </div>
  </bita-modal>
</template>

<script>
import StateFilter from "./../../components/StateFilter";

export default {

      components: { StateFilter },

  props: {
    id: String,
    title: String,
    isLoading: Boolean,
  },
  data() {
    return {
      colWidth: "col-lg-6",
      isLoadingModal: false,
      formData: {
        from: "",
        to: "",
        state_id: null,
        search:""
      },
    };
  },
  watch: {
    isLoading(val) {
      this.isLoadingModal = val;
    },
  },
  methods: {
    reset() {
      this.formData = { from: "", to: "" ,state_id:null,search:""};
      if (this.$refs.form) this.$refs.form.reset();
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.formData);
          this.reset();
        }
      });
    },
  },
};
</script>
